import React, { Component } from 'react'
import {
    MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse, MDBDropdown,
    MDBDropdownToggle, MDBDropdownMenu, MDBDropdownItem, MDBIcon, MDBFormInline, Link
} from "mdbreact";
import {  MDBContainer, MDBMask, MDBView } from 'mdbreact';
import { Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip } from 'antd';
import { URL } from '../api';



export default class Header extends Component {


  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      nameuser: '',
      admin_type: '',
      Username: '',
      collapse: false,
      isWideEnough: false,
    };
    this.onClick = this.onClick.bind(this);
    this.pdf = this.pdf.bind(this);
    this.pdf2 = this.pdf2.bind(this);
  }

  onClick() {
    this.setState({
      collapse: !this.state.collapse,
    });
  }

  pdf() {
    
     // window.location.href = 'https://e-student.kpru.ac.th/webregisfinish/download/Manualregister.pdf '
      window.open('https://e-student.kpru.ac.th/webregisfinish/download/Manualregister.pdf ', '_blank');

    }
    pdf2() {
    
      // window.location.href = 'https://e-student.kpru.ac.th/webregisfinish/download/Manualregister.pdf '
       window.open('https://std.kpru.ac.th/kpnnews/prnews/file/schedule-graduate-kpru-2565.pdf ', '_blank');
 
     }

  
    

    toggleCollapse = () => {
        this.setState({ isOpen: !this.state.isOpen });
    }



    componentDidMount() {
      //  const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('name') !== "") {
          this.setState({ nameuser: localStorage.getItem('name') })
          this.setState({ admin_type: localStorage.getItem('admin_type') })
        } else {
    
            this.setState({ admin_type: 'public' })

        }

         // this.setState({ nameuser: localStorage.getItem('nameuser') })
         // this.setState({ admin_type: localStorage.getItem('admin_type') })
      }


      logout() {
      //   localStorage.removeItem(('admin_type'))
       //  localStorage.removeItem(('nameuser'))
        localStorage.clear();
    
        setTimeout(() => {
          window.location.href = 'https://e-student.kpru.ac.th/vaccinekpru'
        }, 1000);
       // this.setState({ admin_type: 'public' }
        message.success("ออกจากระบบแล้ว")
      }



    render() {



        let logout
        logout = (
          <>
            <MDBNavItem>
              <MDBNavLink to="/main"> {this.state.nameuser}</MDBNavLink>
    
            </MDBNavItem>
           
            <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/">  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
    
        let superadmin
        superadmin = (
          <>
            {/* <MDBNavItem >
                 <MDBNavLink to="/Check"><MDBIcon icon="file-alt" /> หน้าหลัก</MDBNavLink>
            </MDBNavItem> */}
            <MDBNavItem >
                 <MDBNavLink to="/Stuall"><MDBIcon far icon="user-circle" /> นักศึกษา</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Personnelpage"><MDBIcon icon="user-circle" /> บุคลากร</MDBNavLink>
            </MDBNavItem>
            <MDBNavItem >
                 <MDBNavLink to="/Report"><MDBIcon far icon="address-card" /> รายงานข้อมูลสถานะ</MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem >
                 <MDBNavLink to="/Learn"><MDBIcon far icon="chart-bar" />ตารางเรียน</MDBNavLink>
            </MDBNavItem> */}
            {/* <MDBNavItem >
                 <MDBNavLink to="/Classroom"><MDBIcon far icon="chart-bar" />จัดการห้องเรียน</MDBNavLink>
            </MDBNavItem> */}
           


             <MDBNavItem onClick={this.logout} >
              <MDBNavLink to="/"><MDBIcon icon="sign-out-alt" />  ออกจากระบบ </MDBNavLink>
            </MDBNavItem>
          </>
        )
        

    


        let publics
        publics = (
          <>
            <MDBNavItem  >
              <MDBNavLink to="/">   หน้าหลัก </MDBNavLink>
            </MDBNavItem>
            {/* <MDBNavItem>
              <MDBDropdown>
                <MDBDropdownToggle nav caret>
                  <span className="mr-2">ประกาศ</span>
                </MDBDropdownToggle>
                <MDBDropdownMenu>
                  <MDBDropdownItem href="https://std.kpru.ac.th/kpnnews/prnews/file/graduate-kpru-2565.pdf"  target="_blank">ประกาศการรายงานตัวของบัณฑิต</MDBDropdownItem>
               
                 
                </MDBDropdownMenu>
              </MDBDropdown>
            </MDBNavItem> */}
            {/* <MDBNavItem onClick={this.pdf} >
             <MDBNavLink to=""> คู่มือการลงทะเบียน</MDBNavLink>
            
            </MDBNavItem> */}
            {/* <MDBNavItem onClick={this.pdf2} >
             <MDBNavLink to=""> กำหนดการ</MDBNavLink>
            
            </MDBNavItem> */}
            {/* <MDBNavItem  >
              <MDBNavLink to="/">   ส่งผลการวิ่ง </MDBNavLink>
            </MDBNavItem>
            <MDBNavItem  >
              <MDBNavLink to="/">   ตรวจสอบผลการวิ่ง </MDBNavLink>
            </MDBNavItem>
            <MDBNavItem  >
              <MDBNavLink to="/">   กติกาและข้อมูล </MDBNavLink>
            </MDBNavItem>
            <MDBNavItem  >
              <MDBNavLink to="/">   แอปพลิเคชัน </MDBNavLink>
            </MDBNavItem> */}
           
            {/* <MDBNavItem  >
              <MDBNavLink to="/main/LoginPages">  เข้าสู่ระบบ </MDBNavLink>
            </MDBNavItem> */}
          
          </>
        )

        const name = this.state.nameuser;

        return (
            <>
                <MDBNavbar color="warning-color-dark" dark expand="md" >
                    <MDBNavbarBrand>
                    
                        {/* <strong className="white-text"><MDBIcon fas icon="user-graduate" /> KPRUGRADUATION65</strong> */}
                        <strong className="white-text"><MDBIcon fas icon="user-graduate" /> GRADCEREMONY</strong>
                       
                    </MDBNavbarBrand>
                    <MDBNavbarToggler onClick={this.toggleCollapse} />
                    <MDBCollapse id="navbarCollapse3" onCollapse={(e)=>{console.log(e)}} isOpen={this.state.isOpen}  navbar>
                        <MDBNavbarNav left>

                            {/* <MDBNavItem >
                                <MDBNavLink to="/"><MDBIcon icon="home" /> Home</MDBNavLink>
                            </MDBNavItem> */}
                      {/* { localStorage.getItem('name') == null ? <>
                      {publics}
                     {window.location.href = '/tess'} 
                      </>:<>
                       {this.state.admin_type === '2' ? <>
                                      {superadmin}
                                      </> : null}
                      </>} */}
                                                
                                      {/* {this.state.admin_type === '2' ? <>
                                      {superadmin}
                                      </> : null} */}

                                      {this.state.admin_type === null ? <>
                                      {publics}
                                      </> : null}

                                      {/* {this.state.admin_type === '4' ? <>
                                      {adminfaculty}
                                      </> : null}   */}
                              

                        </MDBNavbarNav>
                        <MDBNavbarNav right>
                            <MDBNavItem>
                                <MDBFormInline waves>
                                    <div className="md-form my-0">
                                        {/* <input className="form-control mr-sm-2" type="text" placeholder="Search" aria-label="Search" /> */}
                                        {/* <MDBNavLink to=""><MDBIcon icon="home" /> {this.name} </MDBNavLink> */}
                                    </div>
                                </MDBFormInline>
                            </MDBNavItem>
                        </MDBNavbarNav>
                    </MDBCollapse>
                </MDBNavbar>


                

            </>
        )
    }
}

